import React, { useRef, useState } from 'react'
import { useAddDeviceImageMutation } from './service'
import DialogQuestion from '@/components/Dialog/Dialog'
import { LoadingButton } from '@mui/lab'
import { Box, Typography } from '@mui/material'

interface Props {
  imageId?: string | null
  onImageUploaded?: (imageId: string | null) => void
}

const ACCEPT_IMAGE = 'image/jpeg,image/png,image/gif'

const SystemUploadImg = ({ onImageUploaded, imageId }: Props) => {
  const [openDialogUpload, setOpenDialogUpload] = useState(false)
  const [uploadedImgUrl, setUploadedImgUrl] = useState<string | null>(null)
  const [addDeviceImage, { isLoading }] = useAddDeviceImageMutation()
  const inputRef = useRef<HTMLInputElement>(null)

  const handleUploadClick = () => {
    inputRef.current?.click()
  }

  const handleRemoveImage = () => {
    setUploadedImgUrl(null)
    onImageUploaded?.(null)
  }

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return
    const formData = new FormData()
    formData.append('deviceId', '0')
    formData.append('image', file)
    try {
      const res = await addDeviceImage(formData).unwrap()
      if (res.success && res.id) {
        onImageUploaded?.(res.id)
        setUploadedImgUrl(res.imgUrl)
      }
    } finally {
      e.target.value = ''
    }
  }

  const modalContent = uploadedImgUrl ? (
    <Box sx={{ minWidth: '300px', minHeight: '300px' }}>
      <img
        style={{
          maxWidth: '100%',
          maxHeight: '75vh',
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        }}
        src={uploadedImgUrl}
        alt='Загруженное изображение'
      />
    </Box>
  ) : (
    <Box sx={{ minWidth: '300px' }}>
      <Typography>Загрузите изображение</Typography>
    </Box>
  )

  return (
    <>
      <input
        ref={inputRef}
        type='file'
        accept={ACCEPT_IMAGE}
        hidden
        onChange={handleFileChange}
      />
      <DialogQuestion
        open={openDialogUpload}
        handleClose={() => setOpenDialogUpload(false)}
        handleAgree={uploadedImgUrl ? handleRemoveImage : handleUploadClick}
        showClose={true}
        closeText={'Закрыть'}
        agreeText={uploadedImgUrl ? 'Удалить' : 'Загрузить'}
        loading={isLoading}
        message={modalContent}
        fullWidth={true}
        maxWidth={false}
      />
      <LoadingButton
        variant='text'
        color={(imageId ?? '') ? 'success' : 'primary'}
        onClick={() => setOpenDialogUpload(true)}
      >
        Изображение
      </LoadingButton>
    </>
  )
}

export default SystemUploadImg
